import React from "react";
import "./FeaturedProject.css";
import { Fade } from "react-reveal";
import { featuredProject } from "../../portfolio";

function isSpotlightActive() {
  const start = new Date(featuredProject.spotlightStartDate);
  const end = new Date(start);
  end.setDate(end.getDate() + featuredProject.spotlightDurationDays);
  return new Date() < end;
}

export default function FeaturedProject({ theme }) {
  if (!isSpotlightActive()) return null;

  return (
    <div className="main">
      <Fade bottom duration={2000} distance="40px">
        <a
          className="featured-project-div"
          style={{ backgroundColor: theme.highlight }}
          href={featuredProject.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p
            className="featured-project-tagline"
            style={{ color: theme.secondaryText }}
          >
            {featuredProject.tagline}
          </p>
          <p className="repo-name" style={{ color: theme.text }}>
            {featuredProject.name}
          </p>
          <p
            className="repo-description featured-project-description"
            style={{ color: theme.text }}
          >
            {featuredProject.description}
          </p>
          <div className="professional-project-tech">
            {featuredProject.tech.map((tech) => (
              <span
                key={tech}
                className="professional-project-tech-tag"
                style={{ color: theme.text, borderColor: theme.text }}
              >
                {tech}
              </span>
            ))}
          </div>
        </a>
      </Fade>
    </div>
  );
}
